// extracted by mini-css-extract-plugin
module.exports = {"selectedAmount":"amount_selectedAmount__eNEZC","amount":"amount_amount__X9cFq","focus-visible":"amount_focus-visible__K_NP_"};